<div class="ui-g">
  <div class="ui-g-12">
    <h1>Supplier Ratings</h1>
    <div class="ui-g-12" style="background: #f1f3f6">
      <div class="ui-g-12" style="background: white">
        <div class="ui-g">
          <div class="ui-g-3">
            <span class="ui-g-5">Job Number:</span>
            <span class="ui-g-6">123456</span>
          </div>
          <div class="ui-g-3">
            <span class="ui-g-6">Pick-up Location:</span>
            <span class="ui-g-6">Birmingham</span>
          </div>
        </div>
        <div class="ui-g">
          <div class="ui-g-3">
            <span class="ui-g-5">Date of Job: </span>
            <span class="ui-g-6">10/04/17</span>
          </div>
          <div class="ui-g-3">
            <span class="ui-g-6">Drop-off Location:</span>
            <span class="ui-g-6">London</span>
          </div>
        </div>
        <div class="ui-g">
          <div class="ui-g-3">
            <span class="ui-g-5">Supplier: </span>
            <span class="ui-g-6">{{ Supplier }}</span>
          </div>
        </div>
        <br />
        <h1>Overall, how satisfied were you with {{ Supplier }}?</h1>
        <div class="ui-g-12">
          <div class="ui-g-1 vme-centered">
            <svg
              viewBox="0 0 306 306"
              height="70px"
              width="70px"
              class="vme-star star-rate-card-off"
              (click)="rate($event, 1)"
            >
              <polygon
                points="153,230.775 247.35,299.625 211.65,187.425 306,
                                     121.125 191.25,121.125 153,6.375 114.75,121.125 0,
                                     121.125 94.35,187.425 58.65,299.625"
              ></polygon></svg
            ><br />
            <span>Not at all satisfied</span>
          </div>
          <div class="ui-g-1 vme-centered">
            <svg
              viewBox="0 0 306 306"
              height="70px"
              width="70px"
              class="vme-star star-rate-card-off"
              (click)="rate($event, 2)"
            >
              <polygon
                points="153,230.775 247.35,299.625 211.65,187.425 306,
                                     121.125 191.25,121.125 153,6.375 114.75,121.125 0,
                                     121.125 94.35,187.425 58.65,299.625"
              ></polygon>
            </svg>
          </div>
          <div class="ui-g-1 vme-centered">
            <svg
              viewBox="0 0 306 306"
              height="70px"
              width="70px"
              class="vme-star star-rate-card-off"
              (click)="rate($event, 3)"
            >
              <polygon
                points="153,230.775 247.35,299.625 211.65,
                                     187.425 306,121.125 191.25,121.125 153,6.375 114.75,
                                     121.125 0,121.125 94.35,187.425 58.65,299.625"
              ></polygon>
            </svg>
          </div>
          <div class="ui-g-1 vme-centered">
            <svg
              viewBox="0 0 306 306"
              height="70px"
              width="70px"
              class="vme-star star-rate-card-off"
              (click)="rate($event, 4)"
            >
              <polygon
                points="153,230.775 247.35,299.625 211.65,187.425 306,
                                     121.125 191.25,121.125 153,6.375 114.75,121.125 0,
                                     121.125 94.35,187.425 58.65,299.625"
              ></polygon>
            </svg>
          </div>
          <div class="ui-g-1 vme-centered">
            <svg
              viewBox="0 0 306 306"
              height="70px"
              width="70px"
              class="vme-star star-rate-card-off"
              (click)="rate($event, 5)"
            >
              <polygon
                points="153,230.775 247.35,299.625 211.65,187.425 306,
                                     121.125 191.25,121.125 153,6.375 114.75,121.125 0,
                                     121.125 94.35,187.425 58.65,299.625"
              ></polygon></svg
            ><br />
            <span>Very satisfied</span>
          </div>
        </div>
        <br />
        <h1>{{ RightWrong }}?</h1>
        <div>
          <div class="ui-g" *ngIf="Complains.length > 0">
            <div
              id="complain_{{ complain.id }}"
              class="ui-g-4 q2-box rate-card-off"
              *ngFor="let complain of Complains"
              (click)="selectWrongOption($event)"
            >
              {{ complain.name }}
            </div>
          </div>
        </div>
        <br />
        <h1>Please enter any feedback for {{ Supplier }}</h1>
        <textarea style="width: 51.5%; height: 100px" [(ngModel)]="rateobj.Feedback"></textarea>
        <br />
        <div class="footerPanel ui-grid-row">
          <button
            type="button"
            class="btn-to-right"
            pButton
            (click)="save()"
            icon="fa ui-icon-check"
            label="Save"
          ></button>
        </div>
      </div>
    </div>
  </div>
</div>
